import AccordionSection from '../BaseComponents/AccordionSection'
import FictitiousOrganisationsPreference from '../FictitiousOrganisationsPreference/FictitiousOrganisationsPreference'
import UpgradeRequestForm from '../UpgradeRequestForm/UpgradeRequestForm'
import { SettingsGroup, SettingsItem } from '../SettingsLayout/SettingsLayout'
import useUserData from '../../hooks/useUserData'

// The "User" settings group, shared by Account Settings and the reduced picker layout's settings.
function UserSettingsSection() {
	const userData = useUserData()

	return (
		<AccordionSection id='settings-user' title='User' defaultOpen>
			<SettingsGroup>
				{userData.canRequestUpgrade && (
					<SettingsItem
						title='Account upgrade'
						description='You have a limited account. Request an upgrade to link your account to a real organisation.'
					>
						<UpgradeRequestForm
							idPrefix='upgrade-request'
							kind='upgrade'
							reasonLabel='Reason (optional)'
							reasonPlaceholder="Optional: tell us why you'd like to upgrade"
							submitText='Request Upgrade'
							pendingText='Your upgrade request is pending review by an admin. You can send another request above.'
						/>
					</SettingsItem>
				)}
				<FictitiousOrganisationsPreference />
			</SettingsGroup>
		</AccordionSection>
	)
}

export default UserSettingsSection
